export const LOGOUT_ACTION_PREFIX = 'LOGOUT';
